interface CompanyCodeResult {
    isValid: boolean;
}

export function validateCompanyCode(companyCode: string): CompanyCodeResult {
    if (!/^\d{9}$/.test(companyCode)) {
        return { isValid: false };
    }

    return { isValid: true };
}
